const initialState = {
	promotions: [],
	selected_promotion: null,
	busy: false
}

const promotions = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_SELECTED_PROMOTION': {
			return {
				...state
			}
		}
		case 'DELETE_PROMOTION':
			return { ...state, busy: true }
		case 'DELETE_PROMOTION_SUCCESS':
			return { ...state, busy: false }
		case 'DELETE_PROMOTION_FAIL':
			return { ...state, busy: false }
		case 'REDEEM_PROMOTION':
			return { ...state, busy: true }
		case 'REDEEM_PROMOTION_SUCCESS':
			return { ...state, busy: false }
		case 'REDEEM_PROMOTION_FAIL':
			return { ...state, busy: false }
		case 'SAVE_PROMOTION':
			return { ...state, busy: true, error: null }
		case 'SAVE_PROMOTION_SUCCESS':
			const updatedPromoArray = [...state.promotions]
			updatedPromoArray.unshift(action.payload)
			return { ...state, promotions: updatedPromoArray, busy: false, error: null }
		case 'SAVE_PROMOTION_FAIL':
			return { ...state, busy: false, error: action.payload }
		case 'UPDATE_PROMOTION':
			return { ...state, busy: true, error: null }
		case 'UPDATE_PROMOTION_SUCCESS':
			console.log('ACTION...', action.payload)
			const { promo_id, updates } = action.payload
			const { deleted } = updates
			let updatedPromotions = []
			if (deleted) {
				updatedPromotions = state.promotions.filter((promo) => promo._id !== promo_id)
			} else {
				updatedPromotions = state.promotions.map((promo) => {
					if (promo._id === promo_id) {
						return { ...promo, ...updates }
					}
					return promo
				})
			}

			console.log('THE UPDATED PROMOS...', updatedPromotions)

			return { ...state, promotions: updatedPromotions, busy: false, error: null }
		case 'UPDATE_PROMOTION_FAIL':
			return { ...state, busy: false, error: action.payload }
		case 'FETCH_PROMOTIONS':
			return { ...state, busy: true, error: null }
		case 'FETCH_PROMOTIONS_SUCCESS':
			return { ...state, promotions: [...action.payload], busy: false, error: null }
		case 'FETCH_PROMOTIONS_FAIL':
			return { ...state, busy: false, error: action.payload }
		default:
			return state
	}
}

export default promotions
